import { createSlice } from '@reduxjs/toolkit'

export const airSearchPromise = createSlice({
  name: 'airSearchPromise',
  initialState: {},
  reducers: {
    setAirSearchPromiseRequest: (state, action) => {
      return action.payload
    },
  },
})

export const { setAirSearchPromiseRequest } = airSearchPromise.actions
